import { ApiAbstract } from '../abstract';
import {
  IOrganizationSettings,
  IStaffSettings,
  ISubdivisionSettings,
} from '../../../types/configuration';

export class ApiUpdateConfiguration extends ApiAbstract<
  ISubdivisionSettings | IOrganizationSettings | IStaffSettings,
  ISubdivisionSettings | IOrganizationSettings | IStaffSettings
> {}
